import React from 'react'
import PropTypes from 'prop-types'
import { convertMdToHtml } from '..'
import Interweave from 'interweave'
import { isEmpty } from 'lodash-es'
import Section from '../../Section'
import { hasTools } from '../utils'

const AutomatedAnalysis = ({ report: { reportContent } }) => (
  <Section title="Automated Analysis">
    {hasTools(reportContent.breakdownAndAutomatedAnalysis.tools)
      ? reportContent.breakdownAndAutomatedAnalysis.tools.map((tool, i) =>
          !isEmpty(tool.description) ? (
            <div key={i}>
              <h4>{tool.name.label}</h4>
              <Interweave content={convertMdToHtml.makeHtml(tool.description)} />
            </div>
          ) : null,
        )
      : 'N/A'}
  </Section>
)

AutomatedAnalysis.propTypes = {
  report: PropTypes.object,
}

export default AutomatedAnalysis
